import React, { useState, useEffect, useCallback } from 'react';
import { Table } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import Layout from 'web/components/Layout';
import AlertModal from 'web/components/AlertModal';
import Button from 'web/components/Button';
import Spinner from 'web/components/Spinner';
import {
    networkAll,
    searchByStateCity,
    addNetwork,
    deleteNetwork,
    getNetwork,
    invitationAccept,
    createNetwork
} from 'redux/actions/myNetwork/';

import { NetworkRequestsContainer } from './networkRequestStyled'
const NetworkRequests = () => {
    const [response, setResponse] = useState(undefined);
    const [groupIndex, setGroupIndex] = useState(0);
    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );

    const dispatch = useDispatch();
    let history = useHistory();
    const [totalCountState, setTotalCountState] = useState({
        total: 0,
        pending: 0,
        accepted: 0
    });


    const token = localStorage.getItem('token');

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    const fetchMyAPI = useCallback(async () => {
        if (token === null) {
            history.push('/sign-in');
            window.location.reload(false);
        } else {
            let response = await dispatch(networkAll(token));
            if (response.status === 'SUCCESS') {
                if (response.payload.length !== 0) {
                    setResponse(response.payload);
                }
            } else {
                if (response.statusCode === 401) {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(response.message);
                    setModalLink('');
                    toggleModal();
                }
            }
        }
    }, []);
    useEffect(() => {
        fetchMyAPI();
    }, [fetchMyAPI]);

    const statusSet = (status) => {
        if (status === "PENDING") {
            status = <span className="orangeStatus">Pending</span>
        } else if (status === "ACCEPTED") {
            status = <span className="greenStatus">Accepted</span>
        } else if (status === "AVAILABLE") {
            status = <span className="greenStatus">Available</span>
        } else if (status === "PLACED") {
            status = <span className="orangeStatus">Placed</span>
        } else if (status === "HANDSHAKE_TIMEOUT") {
            status = <span className="redStatus" >Response Timeout</span>
        } else if (status === "PENDING_HANDSHAKE") {
            status = <span className="orangeStatus">Pending Response</span>
        } else if (status === "BIDDING_CLOSE") {
            status = <span className="redStatus">Expired</span>
        }
        return status;
    };

    const acceptReject = async (index) => {
        let data = {
            networkId: response[groupIndex].id,
            userId: "5fc924aa9334574d7d4c956a",
            memberState: "ACCEPTED"
        }
        if (token === null) {
            history.push('/sign-in');
            window.location.reload(false);
        } else {
            let deleteResponse = await dispatch(invitationAccept(data, token));
            if (deleteResponse.status === 'SUCCESS') {
                setModalContent(deleteResponse.message);
                setModalLink('');
                toggleModal();
                fetchMyAPI();
            } else {
                if (deleteResponse.statusCode === 401) {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(deleteResponse.message);
                    setModalLink('');
                    toggleModal();
                }
            }
        }
    }

    let headerArr = [
        {
            title: 'Group Name',
        },
        {
            title: 'From',
        },
        {
            title: 'Action',
        },
    ];

    return (<>
        <Layout transparentHeader={false} topBarViewMobile={"hide"}>
            <NetworkRequestsContainer>
                {loaderVisible && <Spinner />}
                <h1 className='heading'>Community Requests</h1>

                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    {response ? (
                        <tbody>
                            {[0, 1, 2, 3].map((items, index) => (
                                <tr>
                                    <td>Name</td>
                                    <td>From</td>
                                    <td>
                                        <Button
                                            type='app-green-button'
                                            handleClick={(e) => {
                                                acceptReject(index, "ACCEPTED")
                                            }}>
                                            Accept
                                        </Button>
                                    </td>
                                </tr>
                            ))}


                        </tbody>
                    ) : (<div className='noRecordFound'>No records found</div>)}
                </Table>

                <AlertModal
                    isOpen={modal}
                    toggle={toggleModal}
                    title=''
                    content={modalContent}
                    link={modalLink}
                />
            </NetworkRequestsContainer>
        </Layout>
    </>
    )
}



export default NetworkRequests;
